// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZYIqm","type":"styles_type__1Qh_T","choices":"styles_choices__2T3IF"};